import React from 'react'
import { iconMap } from '@mortgage-pos/ui/utils/customizationHelpers'

const HowItWorks = () => {
  return (
    <div className="br-how-it-works__container">
      <div className="br-how-it-works__blurb-container">
        <h1 className="br-how-it-works__heading">How it works</h1>
        <p className="br-how-it-works__description">
          We'll use your address to understand your current mortgage and work
          our analysis magic to compare it against our huge database of mortgage
          offers.
          <br />
          <br />
          In a few seconds, you'll see a curated list of your top personalized
          offers. Compare them, choose one, then easily request a full quote and
          get moving toward a better mortgage.
        </p>
        <br />
        <h2 className="br-how-it-works__sub-heading">
          Yep, it's really that easy.{' '}
          <span className="br-how-it-works__promise-heading">Promise.</span>
        </h2>
      </div>
      <img
        src={iconMap('brRateTable')}
        alt="Rate Table"
        className="br-how-it-works__rate-table-image"
      />
    </div>
  )
}

export default HowItWorks
